var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-payment"},[_c('div',{staticClass:"modal-content-sc"},[_c('img',{attrs:{"src":"/images/sorry-icon.svg"}}),_c('h6',[_vm._v("Payment Failed!")]),_c('p',[_vm._v("Try Again.")]),_c('router-link',{staticClass:"subscription-btn",attrs:{"to":{ name: 'Home' }}},[_vm._v("Go Home")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }